// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// Components, Layouts, Pages
import { Loading } from '~/components/common';
import { TableQuoteItemsQuoteDetail } from '~/components/module/quotes';
// Others
import { TypeQuoteDetailEnum } from '~/utils/enum/common';
import { getDetailQuote } from '~/thunks/quote/quoteThunk';
import { IOverbookedItemDetail, IQueryParamQuoteDetail } from '~/utils/interface/quotes';
import { useAppDispatch } from '~/utils/redux/hooks';
// Styles, images, icons
import styles from './OverbookedQuoteTab.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const OverbookedQuoteTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { id: quoteId } = useParams();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [overbookedItemsDetail, setOverbookedItemsDetail] = useState<IOverbookedItemDetail>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!quoteId) return;

    const params: IQueryParamQuoteDetail = {
      quoteId: quoteId,
      type: TypeQuoteDetailEnum.OVERBOOKED_ITEMS,
    };

    handleGetDetailQuote(params);
  }, []);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetDetailQuote = (params: IQueryParamQuoteDetail) => {
    setIsLoading(true);

    dispatch(getDetailQuote(params))
      .unwrap()
      .then((res) => {
        const { data } = res;

        setOverbookedItemsDetail(data as IOverbookedItemDetail);
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  //#endregion Handle Function

  return (
    <Box id='overbookedQuoteTabComponent'>
      <TableQuoteItemsQuoteDetail overbookedItems={overbookedItemsDetail} />

      {isLoading && <Loading />}
    </Box>
  );
};

export default OverbookedQuoteTab;
